var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{class:[_vm.selectedColumnClass, _vm.columnClass],on:{"click":_vm.sortByColumn}},[_c('span',[_c('i',{class:_vm.sortOrderClass}),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }